import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';

export function useAuthStatus() {
  const router = useRouter();
  const [showSuspendedModal, setShowSuspendedModal] = useState(false);
  const [suspendMessage, setSuspendMessage] = useState('');

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          return;
        }

        const response = await fetch('/api/auth/check-status', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const data = await response.json();

        // If user is suspended or deleted, logout
        if (!data.isValid || data.status === 'suspended' || data.status === 'deleted') {
          console.log('🚫 User account is no longer active. Logging out...');
          
          // Clear local storage
          localStorage.removeItem('authToken');
          localStorage.removeItem('user');
          
          // Set message and show modal
          setSuspendMessage(data.message || 'Your account has been suspended or deleted.');
          setShowSuspendedModal(true);
          
          // Redirect after 3 seconds
          setTimeout(() => {
            router.push('/login');
          }, 3000);
        }
      } catch (error) {
        console.error('Auth status check failed:', error);
      }
    };

    // Check immediately
    checkAuthStatus();

    // Check every 30 seconds
    const interval = setInterval(checkAuthStatus, 30000);

    return () => clearInterval(interval);
  }, [router]);

  return { showSuspendedModal, suspendMessage };
}
